import { put, select, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../../constants/action-types';
import {
  createDefaultRateOption,
  getSelected,
} from '../selected-rate/selectors';
import { OptionTypes } from './../../../models/itinerary';
import { SelectOptionAction, SelectOptionWithRateAction } from './types';

export function* watcherSaga() {
  yield takeLatest(ActionTypes.OPTION_SELECT, worker);
}

function* worker(action: SelectOptionAction) {
  const { optionId, segmentId } = action;
  const selectedRate: OptionTypes | undefined = yield select(getSelected);
  const defaultRate: OptionTypes = yield select(
    createDefaultRateOption(segmentId, optionId),
  );
  const newAction: SelectOptionWithRateAction = {
    ...action,
    type: ActionTypes.OPTION_SELECT_WITH_RATE,
    option: selectedRate || defaultRate,
  };

  yield put(newAction);
}
